module.exports = __webpack_public_path__ + "media/images/bnr-insta-feed-detailed-7037d2bcb6bed35e8e18f3eb8e0df5b1.png";